// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vxeTable[data-v-2b3ad17e] {\n  height: 60vh;\n}\n.dialog-footer[data-v-2b3ad17e] {\n  position: absolute;\n  bottom: 0;\n  right: 20px;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  z-index: 99;\n  background-color: white;\n}\n.search[data-v-2b3ad17e] {\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
